import { Injectable, inject } from '@angular/core';
import { select, Store, Action } from '@ngrx/store';

import * as CustomActions from './custom.actions';
import * as CustomFeature from './custom.reducer';
import * as CustomSelectors from './custom.selectors';

@Injectable()
export class CustomFacade {
  private readonly store = inject(Store);

  /**
   * Combine pieces of state using createSelector,
   * and expose them as observables through the facade.
   */

  customConversionList$ = this.store.pipe(select(CustomSelectors.GetCustomConversionList));
  customTruckList$ = this.store.pipe(select(CustomSelectors.GetCustomTruckList));
  customReuseList$ = this.store.pipe(select(CustomSelectors.GetCustomReuseList));
  customStorageList$ = this.store.pipe(select(CustomSelectors.GetCustomStorageList));
  customFillingList$ = this.store.pipe(select(CustomSelectors.GetCustomFillingList));
  customTransportList$ = this.store.pipe(select(CustomSelectors.GetCustomTransportList));
  customWasteList$ = this.store.pipe(select(CustomSelectors.GetCustomWasteList));
  materialIngredientList$ = this.store.pipe(select(CustomSelectors.GetMaterialIngredientList));
  copiedMaterialIngredient$ = this.store.pipe(select(CustomSelectors.GetcopiedMaterialIngredient));
  isIngredirentEdit$ = this.store.pipe(select(CustomSelectors.isIngredirentEdit));
  materialProcessList$ = this.store.pipe(select(CustomSelectors.GetMaterialProcessList));
  conversionProcessList$ = this.store.pipe(select(CustomSelectors.GetConversionProcessList));
  customMaterialError$ = this.store.pipe(select(CustomSelectors.GetCustomMaterialError));
  customMaterialIngredirentError$ = this.store.pipe(
    select(CustomSelectors.GetCustomMaterialIngredirentError)
  );
  GetCustomMaterialProcessError$ = this.store.pipe(
    select(CustomSelectors.GetCustomMaterialProcessError)
  );
  GetCustomConversionProcessError$ = this.store.pipe(
    select(CustomSelectors.GetCustomConversionProcessError)
  );
  conversionData$ = this.store.pipe(select(CustomSelectors.GetConversionData));
  truckData$ = this.store.pipe(select(CustomSelectors.GetCustomTruckData));
  fillingData$ = this.store.pipe(select(CustomSelectors.GetCustomFillingData));
  errorMessage$ = this.store.pipe(select(CustomSelectors.DisplayErrorMessage));
  customTruckError$ = this.store.pipe(select(CustomSelectors.GetCustomMaterialError));
  customFillingError$ = this.store.pipe(select(CustomSelectors.GetCustomFillingProcessError));
  truckTypeList$ = this.store.pipe(select(CustomSelectors.GetTruckTypeList));
  fillingIngredientList$ = this.store.pipe(select(CustomSelectors.GetFillingIngredientList));
  copiedFillingIngredient$ = this.store.pipe(select(CustomSelectors.GetcopiedFillingIngredient));
  isIngredirentEditFilling$ = this.store.pipe(select(CustomSelectors.isIngredirentEditFilling));
  storageProcessList$ = this.store.pipe(select(CustomSelectors.GetStorageProcessList));
  GetStorageData$ = this.store.pipe(select(CustomSelectors.GetStorageData));
  copiedStorageProcess$ = this.store.pipe(select(CustomSelectors.GetcopiedStorageProcess));
  isProcessEditStorage$ = this.store.pipe(select(CustomSelectors.isProcessEditStorage));
  customStorageError$ = this.store.pipe(select(CustomSelectors.GetCustomStorageError));
  customReuseError$ = this.store.pipe(select(CustomSelectors.GetCustomReuseError));
  wasteScenarioProcessList$ = this.store.pipe(select(CustomSelectors.GetWasteScenarioProcessList));
  wasteScenarioData$ = this.store.pipe(select(CustomSelectors.GetWasteScenarioData));
  copiedWasteScenarioProcess$ = this.store.pipe(
    select(CustomSelectors.GetcopiedWasteScenarioProcess)
  );
  isProcessEditWasteScenario$ = this.store.pipe(select(CustomSelectors.isProcessEditWasteScenario));
  customWasteScenarioError$ = this.store.pipe(select(CustomSelectors.GetCustomWasteScenarioError));
  wasteGridData$ = this.store.pipe(select(CustomSelectors.GetWasteGridData));
  reuseIngredientList$ = this.store.pipe(select(CustomSelectors.GetReuseIngredientList));
  reuseData$ = this.store.pipe(select(CustomSelectors.GetReuseData));
  isIngredirentEditReuse$ = this.store.pipe(select(CustomSelectors.isIngredirentEditReuse));
  copiedReuseIngredient$ = this.store.pipe(select(CustomSelectors.GetcopiedReuseIngredient));
  customTransportScenarioList$ = this.store.pipe(select(CustomSelectors.GetTransportScenarioList));
  customTransportListRowData$ = this.store.pipe(select(CustomSelectors.GetTransportListRowData));
  customMultipleTransportScenarioList$ = this.store.pipe(
    select(CustomSelectors.GetMultipleTransportScenarioList)
  );
  multipleTransportErrorMsg$ = this.store.pipe(
    select(CustomSelectors.GetMultipleTransportErrorMessage)
  );
  transportErrorMsg$ = this.store.pipe(select(CustomSelectors.GetTransportErrorMessage));
  remainingValue$ = this.store.pipe(select(CustomSelectors.GetRemainingValue));
  replicateTransportScenarioList$ = this.store.pipe(
    select(CustomSelectors.GetReplicaTransportScenarioList)
  );
  newCustomMaterialData$ = this.store.pipe(select(CustomSelectors.GetCustomMaterialData));
  materialItems$ = this.store.pipe(select(CustomSelectors.GetMaterialItems));
  endofLifeIdentifierItems$ = this.store.pipe(select(CustomSelectors.GetEndofLifeIdentifierItems));
  energyItems$ = this.store.pipe(select(CustomSelectors.GetEnergyItems));
  truckList$ = this.store.pipe(select(CustomSelectors.GetTruckListItems));
  refrigerationList$ = this.store.pipe(select(CustomSelectors.GetrefrigerationItems));
  customFillingenergyItems$ = this.store.pipe(select(CustomSelectors.GetCustomFillingEnergyItems));
  unitofProductItems$ = this.store.pipe(select(CustomSelectors.GetUnitofProductItems));
  customStorageEnergyItems$ = this.store.pipe(select(CustomSelectors.GetcustomStorageEnergyItems));
  customReuseEnergyItems$ = this.store.pipe(select(CustomSelectors.GetcustomReuseEnergyItems));
  customWestOrganizationlist$ = this.store.pipe(
    select(CustomSelectors.GetcustomWestOrganizationlist)
  );
  customWestlocationItems$ = this.store.pipe(select(CustomSelectors.GetcustomWestlocationItems));
  customWestWasteMaterialItems$ = this.store.pipe(
    select(CustomSelectors.GetcustomWestWasteMaterialItems)
  );
  organizationItems$ = this.store.pipe(select(CustomSelectors.GetorganizationItems));
  checkUpdateActionFire$ = this.store.pipe(select(CustomSelectors.checkUpdateActionFireSelector));
  distanceErrorProjectCustom$ = this.store.pipe(select(CustomSelectors.distanceErrorProjectCustom));

  setCustomMaterialError(error: any) {
    this.store.dispatch(CustomActions.addEditCustomMaterialFailure({ error: error }));
  }

  setCustomConversionError(error: any) {
    this.store.dispatch(CustomActions.addEditCustomConversionFailure({ error: error }));
  }

  setCustomTransportError(error: any) {
    this.store.dispatch(CustomActions.addEditCustomTransportScenarioFailure({ error: error }));
  }
  setMultipleCustomTransportError(error: any) {
    this.store.dispatch(
      CustomActions.addMultipleTransportScenarioScenarioFailure({ error: error })
    );
  }

  setStorageProccessError(error: any) {
    this.store.dispatch(CustomActions.storageProcessFailure({ error: error }));
  }

  GetCustomConversionList(payload: any, pathName: any) {
    this.store.dispatch(
      CustomActions.getCustomConversionList({ payload: payload, pathName: pathName })
    );
  }

  GetCustomTruckList(payload: any, pathName: any) {
    this.store.dispatch(CustomActions.getCustomTruckList({ payload: payload, pathName: pathName }));
  }

  GetCustomReuseList(payload: any, pathName: any) {
    this.store.dispatch(CustomActions.getCustomReuseList({ payload: payload, pathName: pathName }));
  }

  GetCustomStorageList(payload: any, pathName: any) {
    this.store.dispatch(
      CustomActions.getCustomStorageList({ payload: payload, pathName: pathName })
    );
  }

  GetCustomFillingList(payload: any, pathName: any) {
    this.store.dispatch(
      CustomActions.getCustomFillingList({ payload: payload, pathName: pathName })
    );
  }

  GetCustomTransportList(payload: any, pathName: any) {
    this.store.dispatch(
      CustomActions.getCustomTransportList({ payload: payload, pathName: pathName })
    );
  }

  GetCustomWasteList(payload: any, pathName: any) {
    this.store.dispatch(CustomActions.getCustomWasteList({ payload: payload, pathName: pathName }));
  }

  deleteCustomData(payload: any, customType: any, pathName: any, regionId: any) {
    this.store.dispatch(
      CustomActions.deleteCustomData({ payload, customType, pathName, regionId })
    );
  }

  addMaterialIngredientActions(ingredient: any, action: any, ingredientIndex?: any) {
    this.store.dispatch(
      CustomActions.addMaterialIngredient({ ingredient, action, ingredientIndex })
    );
  }

  updateMaterialIngredientActions(
    ingredient: any,
    action: any,
    ingredientIndex?: any,
    nodeId?: any,
    colId?: any
  ) {
    this.store.dispatch(
      CustomActions.updateMaterialIngredient({ ingredient, action, ingredientIndex, nodeId, colId })
    );
  }

  deleteMaterialIngredientActions(ingredient: any, action: any, ingredientIndex?: any) {
    this.store.dispatch(
      CustomActions.deleteMaterialIngredient({ ingredient, action, ingredientIndex })
    );
  }

  copyMaterialIngredientActions(ingredient: any, action: any, ingredientIndex?: any) {
    this.store.dispatch(
      CustomActions.copyMaterialIngredient({ ingredient, action, ingredientIndex })
    );
  }

  clearMaterialIngredient() {
    this.store.dispatch(CustomActions.clearMaterialIngredient());
  }

  clearMaterialRowData() {
    this.store.dispatch(CustomActions.clearMaterialRowData());
  }

  clearMaterialList() {
    this.store.dispatch(CustomActions.clearMaterialList());
  }

  clearConversionList() {
    this.store.dispatch(CustomActions.clearConversionList());
  }

  clearTruckList() {
    this.store.dispatch(CustomActions.clearTruckList());
  }

  clearReuseList() {
    this.store.dispatch(CustomActions.clearReuseList());
  }

  clearStorageList() {
    this.store.dispatch(CustomActions.clearStorageList());
  }

  clearFillingList() {
    this.store.dispatch(CustomActions.clearFillingList());
  }

  clearCustomWasteList() {
    this.store.dispatch(CustomActions.clearCustomWasteList());
  }
  addCustomWasteScenarioExistingRecord(error: any) {
    this.store.dispatch(CustomActions.addCustomWasteScenarioExistingRecord({ error }));
  }

  clearWasteScenarioRowDataProcess() {
    this.store.dispatch(CustomActions.clearWasteScenarioRowDataProcess());
  }

  addMaterialProcessActions(process: any, action: any, processIndex?: any) {
    this.store.dispatch(CustomActions.addMaterialProcess({ process, action, processIndex }));
  }

  updateMaterialProcessActions(
    process: any,
    action: any,
    processIndex?: any,
    nodeId?: any,
    colId?: any
  ) {
    this.store.dispatch(
      CustomActions.updateMaterialProcess({ process, action, processIndex, nodeId, colId })
    );
  }

  deleteMaterialProcessActions(process: any, action: any, processIndex?: any) {
    this.store.dispatch(CustomActions.deleteMaterialProcess({ process, action, processIndex }));
  }

  addConversionProcessActions(process: any, action: any, processIndex?: any) {
    this.store.dispatch(CustomActions.addConversionProcess({ process, action, processIndex }));
  }

  updateConversionProcessActions(
    process: any,
    action: any,
    processIndex?: any,
    nodeId?: any,
    colId?: any
  ) {
    this.store.dispatch(
      CustomActions.updateConversionProcess({ process, action, processIndex, nodeId, colId })
    );
  }

  copyConversionProcessActions(process: any, action: any, processIndex?: any) {
    this.store.dispatch(CustomActions.copyConversionProcess({ process, action, processIndex }));
  }

  deleteConversionProcessAction(process: any, action: any, processIndex?: any) {
    this.store.dispatch(CustomActions.deleteConversionProcess({ process, action, processIndex }));
  }

  clearMaterialProcess() {
    this.store.dispatch(CustomActions.clearMaterialProcess());
  }

  clearConversionProcess() {
    this.store.dispatch(CustomActions.clearConversionProcess());
  }

  addEditCustomMaterial(customMaterialData: any) {
    this.store.dispatch(
      CustomActions.addEditCustomMaterial({ customMaterialData: customMaterialData })
    );
  }

  addEditCustomConversion(customConversionData: any) {
    this.store.dispatch(
      CustomActions.addEditCustomConversion({ customConversionData: customConversionData })
    );
  }

  inlineDataEdit(customData: any, module: any, pathName: any, nodeId?: any, field?: any) {
    this.store.dispatch(
      CustomActions.inlineDataEdit({
        customData: customData,
        module: module,
        pathName: pathName,
        nodeId: nodeId,
        field: field,
      })
    );
  }

  deleteCustomAction(action: any, customType: any, pathName: any) {
    this.store.dispatch(CustomActions.deleteCustom({ action, customType, pathName }));
  }

  copyCustomActions(action: any, customType: any, pathName: any) {
    this.store.dispatch(CustomActions.customMaterialCopy({ action, customType, pathName }));
  }

  copyCustomData(payload: any, customType: any, pathName: any) {
    this.store.dispatch(CustomActions.copyCustomData({ payload, customType, pathName }));
  }

  openAddEditCustomMaterialModal(customMaterialId: any, actionLabel: any, pathName: any) {
    this.store.dispatch(
      CustomActions.openAddEditCustomMaterialModal({
        customMaterialId: customMaterialId,
        actionLabel: actionLabel,
        pathName: pathName,
      })
    );
  }

  openAddEditCustomConversionModal(customConversionId: any, actionLabel: any, pathName: any) {
    this.store.dispatch(
      CustomActions.openAddEditCustomConversionModal({
        customConversionId: customConversionId,
        actionLabel: actionLabel,
        pathName: pathName,
      })
    );
  }

  addEditCustomFilling(customFillingData: any) {
    this.store.dispatch(
      CustomActions.addEditCustomFilling({ customFillingData: customFillingData })
    );
  }

  openAddEditCustomFillingModal(customFillingId: any, actionLabel: any, pathName: any) {
    this.store.dispatch(
      CustomActions.openAddEditCustomFiliingModal({
        customFillingId: customFillingId,
        actionLabel: actionLabel,
        pathName: pathName,
      })
    );
  }
  openAddEditCustomTruckModal(customTruckId: any, actionLabel: any, pathName: any) {
    this.store.dispatch(
      CustomActions.openAddEditCustomTruckModal({
        customTruckId: customTruckId,
        actionLabel: actionLabel,
        pathName: pathName,
      })
    );
  }

  clearCustomTrucksData() {
    this.store.dispatch(CustomActions.clearCustomTrucksData());
  }

  addEditCustomTruck(customTruckData: any) {
    this.store.dispatch(CustomActions.addEditCustomTruck({ customTruckData: customTruckData }));
  }

  openAddEditCustomTransportScenarioModal(
    customTransportScenarioId: any,
    actionLabel: any,
    pathName: any
  ) {
    this.store.dispatch(
      CustomActions.openAddEditCustomTransportScenarioModal({
        customTransportScenarioId: customTransportScenarioId,
        actionLabel: actionLabel,
        pathName: pathName,
      })
    );
  }

  addEditCustomTransportScenario(customTransportScenarioData: any) {
    this.store.dispatch(
      CustomActions.addEditCustomTransportScenario({
        customTransportScenarioData: customTransportScenarioData,
      })
    );
  }

  clearFillingIngredient() {
    this.store.dispatch(CustomActions.clearFillingIngredient());
  }

  storageProcessActions(ingredient: any, action: any, ingredientIndex?: any) {
    //this.store.dispatch(CustomActions.storageProcess({ ingredient, action, ingredientIndex }))
  }

  addStorageProcessActions(process: any, action: any, processIndex?: any) {
    this.store.dispatch(CustomActions.addStorageProcess({ process, action, processIndex }));
  }

  updateStorageProcessActions(
    process: any,
    action: any,
    processIndex?: any,
    nodeId?: any,
    colId?: any
  ) {
    this.store.dispatch(
      CustomActions.updateStorageProcess({ process, action, processIndex, nodeId, colId })
    );
  }

  deleteStorageProcessActions(process: any, action: any, processIndex?: any) {
    this.store.dispatch(CustomActions.deleteStorageProcess({ process, action, processIndex }));
  }

  copyStorageProcessActions(process: any, action: any, processIndex?: any) {
    this.store.dispatch(CustomActions.copyStorageProcess({ process, action, processIndex }));
  }

  addEditCustomStorage(customStorageData: any) {
    this.store.dispatch(
      CustomActions.addEditCustomStorage({ customStorageData: customStorageData })
    );
  }

  openAddEditCustomStorageModal(customStorageId: any, actionLabel: any, pathName: any) {
    this.store.dispatch(
      CustomActions.openAddEditCustomStorageModal({
        customStorageId: customStorageId,
        actionLabel: actionLabel,
        pathName: pathName,
      })
    );
  }

  clearStorageProcess() {
    this.store.dispatch(CustomActions.clearStorageProcess());
  }

  //Code-refactor of waste scenario data process

  addWasteScenarioDataProcess(
    ingredient: any,
    action: any,
    ingredientIndex?: any,
    wasteGridData?: any
  ) {
    this.store.dispatch(
      CustomActions.addWasteScenarioDataProcess({
        ingredient,
        action,
        ingredientIndex,
        wasteGridData,
      })
    );
  }

  updateWasteScenarioDataProcess(
    ingredient: any,
    action: any,
    ingredientIndex?: any,
    wasteGridData?: any
  ) {
    this.store.dispatch(
      CustomActions.updateWasteScenarioDataProcess({
        ingredient,
        action,
        ingredientIndex,
        wasteGridData,
      })
    );
  }
  checkUpdateActionFire(check: boolean) {
    this.store.dispatch(CustomActions.checkUpdateActionFire({ check }));
  }

  deleteWasteScenarioDataProcess(ingredient: any, action: any, ingredientIndex?: any) {
    this.store.dispatch(
      CustomActions.deleteWasteScenarioDataProcess({ ingredient, action, ingredientIndex })
    );
  }

  copyWasteScenarioDataProcess(ingredient: any, action: any, ingredientIndex?: any) {
    this.store.dispatch(
      CustomActions.copyWasteScenarioDataProcess({ ingredient, action, ingredientIndex })
    );
  }

  addEditCustomWasteScenario(customWasteScenarioData: any) {
    this.store.dispatch(
      CustomActions.addEditCustomWasteScenario({ customWasteScenarioData: customWasteScenarioData })
    );
  }

  openAddEditCustomWasteScenarioModal(customWasteScenarioId: any, actionLabel: any, pathName: any) {
    this.store.dispatch(
      CustomActions.openAddEditCustomWasteScenarioModal({
        customWasteScenarioId: customWasteScenarioId,
        actionLabel: actionLabel,
        pathName: pathName,
      })
    );
  }

  clearWasteScenarioProcess() {
    this.store.dispatch(CustomActions.clearWasteScenariProcess());
  }

  // clearwasteScenarioProcessError() {
  //   this.store.dispatch(CustomActions.clearwasteScenarioProcessError());
  // }

  wasteScenarioProcessGrid(wasteGridData: any, wasteDataList: any) {
    this.store.dispatch(
      CustomActions.wasteScenarioProcessGrid({
        wasteGridData: wasteGridData,
        wasteDataList: wasteDataList,
      })
    );
  }

  openAddEditCustomReuseModal(customReuseId: any, actionLabel: any, pathName: any) {
    this.store.dispatch(
      CustomActions.openAddEditCustomReuseModal({
        customReuseId: customReuseId,
        actionLabel: actionLabel,
        pathName: pathName,
      })
    );
  }

  addEditCustomReuse(customReuseData: any) {
    this.store.dispatch(CustomActions.addEditCustomReuse({ customReuseData: customReuseData }));
  }

  addTransportScenarioActions(transport: any, action: any, index?: any) {
    this.store.dispatch(CustomActions.addTransportScenario({ transport, action, index }));
  }
  updateTransportScenarioActions(transport: any, action: any, index?: any) {
    this.store.dispatch(CustomActions.updateTransportScenarioActions({ transport, action, index }));
  }

  deleteTransportScenarioActions(transport: any, action: any, index?: any) {
    this.store.dispatch(CustomActions.deleteTransportScenario({ transport, action, index }));
  }

  clearTransportScenario() {
    this.store.dispatch(CustomActions.clearAddTransportScenario());
  }

  clearTransportScenarioRowData() {
    this.store.dispatch(CustomActions.clearTransportScenarioRowData());
  }
  clearnDistanceError() {
    this.store.dispatch(CustomActions.clearnDistanceError());
  }

  clearMultipleTransportScenario() {
    this.store.dispatch(CustomActions.clearAddMultipleTransportScenario());
  }

  addMultipleTransportScenarioActions(multiTransport: any, action: any, index?: any) {
    this.store.dispatch(
      CustomActions.addMultipleTransportScenario({ multiTransport, action, index })
    );
  }

  deleteMultipleTransportScenarioActions(multiTransport: any, action: any, index?: any) {
    this.store.dispatch(
      CustomActions.deleteMultipleTransportScenario({ multiTransport, action, index })
    );
  }

  clearCustomWasteScenarioModal() {
    this.store.dispatch(CustomActions.clearCustomWasteScenarioModal());
  }

  ClearAddEditCustomStorageModal() {
    this.store.dispatch(CustomActions.ClearAddEditCustomStorageModal());
  }

  clearCustomReuseModal() {
    this.store.dispatch(CustomActions.clearCustomReuseModal());
  }

  ClearCustomFiliingData() {
    this.store.dispatch(CustomActions.ClearCustomFiliingData());
  }

  clearCustomConversionData() {
    this.store.dispatch(CustomActions.clearCustomConversionData());
  }

  addReuseIngredientAction(ingrediant: any, action: any, processIndex?: any) {
    this.store.dispatch(
      CustomActions.addReuseIngredient({
        ingredient: ingrediant,
        action: action,
        ingredientIndex: processIndex,
      })
    );
  }

  updateReuseIngredientAction(
    ingrediant: any,
    action: any,
    ingredientIndex?: any,
    nodeId?: any,
    colId?: any
  ) {
    this.store.dispatch(
      CustomActions.updateReuseIngredient({
        ingredient: ingrediant,
        action,
        ingredientIndex,
        nodeId,
        colId,
      })
    );
  }

  deleteReuseIngredientAction(ingrediant: any, action: any, ingredientIndex?: any) {
    this.store.dispatch(
      CustomActions.deleteReuseIngredient({ ingredient: ingrediant, action, ingredientIndex })
    );
  }

  copyReuseIngredientAction(ingrediant: any, action: any, ingredientIndex?: any) {
    this.store.dispatch(
      CustomActions.copyReuseIngredient({ ingredient: ingrediant, action, ingredientIndex })
    );
  }

  clearReuseIngredientProces() {
    this.store.dispatch(CustomActions.clearReuseIngredient());
  }

  addfillingIngredientAction(ingrediant: any, action: any, processIndex?: any) {
    this.store.dispatch(
      CustomActions.addfillingIngredient({
        ingredient: ingrediant,
        action: action,
        ingredientIndex: processIndex,
      })
    );
  }

  updatefillingIngredientAction(
    ingrediant: any,
    action: any,
    ingredientIndex?: any,
    nodeId?: any,
    colId?: any
  ) {
    this.store.dispatch(
      CustomActions.updatefillingIngredient({
        ingredient: ingrediant,
        action,
        ingredientIndex,
        nodeId,
        colId,
      })
    );
  }

  deletefillingIngredientAction(ingrediant: any, action: any, ingredientIndex?: any) {
    this.store.dispatch(
      CustomActions.deletefillingIngredient({ ingredient: ingrediant, action, ingredientIndex })
    );
  }

  copyfillingIngredienttAction(ingrediant: any, action: any, ingredientIndex?: any) {
    this.store.dispatch(
      CustomActions.copyfillingIngredient({ ingredient: ingrediant, action, ingredientIndex })
    );
  }

  clearfillingIngredientProces() {
    this.store.dispatch(CustomActions.clearfillingIngredient());
  }
}
